import { HTMLExtUtils } from '@ssml-editor/core';
import { SOUND_EVENT_TYPE } from './constant.js';

const soundEventElementToHtml = ({
  element
}) => {
  const { mark, src } = element;
  return HTMLExtUtils.createElementAsString(SOUND_EVENT_TYPE, true, true, {
    mark,
    src
  });
};

export { soundEventElementToHtml };
//# sourceMappingURL=element-to-html.js.map
